import { render, staticRenderFns } from "./FormLabelCom.vue?vue&type=template&id=42aa8f22&scoped=true"
import script from "./FormLabelCom.vue?vue&type=script&lang=js"
export * from "./FormLabelCom.vue?vue&type=script&lang=js"
import style0 from "./FormLabelCom.vue?vue&type=style&index=0&id=42aa8f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aa8f22",
  null
  
)

export default component.exports